export const AWS_ALIAS = `https://${process.env.REACT_APP_GR_TRIM_CF_URL ?? 'assets.brandlive.com'}`;
export const DOC_TYPES = ['pdf', 'pptx', 'key'];
export const VID_TYPES = ['mp4', 'mov', 'webm', 'm3u8'];
export const IMG_TYPES = ['jpg', 'png', 'jpeg', 'gif'];
export const AUDIO_TYPES = ['mp3', 'wav', 'aac'];
export const NON_DOC_FILE_TYPES = [...VID_TYPES, ...IMG_TYPES, ...AUDIO_TYPES];
export const ALL_FILE_TYPES = [...DOC_TYPES, ...VID_TYPES, ...IMG_TYPES, ...AUDIO_TYPES];

// 5gb
export const MAX_FILE_SIZE = 1024 * 1024 * 1024 * 5;

export const TELEPROMPTER_SECTION_TYPES = {
	SHOT: 1,
	MEDIA: 2,
};

export const TELEPROMPTER_SECTION_STATES = {
	NOT_SELECTED: 0,
	SELECTED: 1,
	PLAYING: 2,
};

export const DURATION_INPUT_TYPES = {
	SECONDS: 1,
	MINUTES: 2,
	SECONDS_AND_MINUTES: 3,
};

export const MEDIA_TYPES = {
	HLS: 'hls',
	MOV: 'mov',
};

export const MEDIA_FILTER_TYPES = {
	ALL: 'All',
	IMAGES: 'Images',
	VIDEOS: 'Videos',
	DOCUMENTS: 'Documents',
};

export const MEDIA_SORT_TYPES = {
	NONE: 'none',
	RECENT_ASC: 'recent-asc',
	RECENT_DESC: 'recent-desc',
	NAME_ASC: 'name-asc',
	NAME_DESC: 'name-desc',
	SHOT_NUMBER_ASC: 'shot-number-asc',
	SHOT_NUMBER_DESC: 'shot-number-desc',
};

export const TRIM_MEDIA_CONTROLS = {
	START: 'start',
	REWIND: 'rewind',
	FORWARD: 'forward',
	END: 'end',
};

export const baseFrameDataCustomGraphics = { translate: [0, 0], rotate: 0, scale: [1, 1] };

export const videoGridClasses = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'none'];

// Max overlays per shot settings
export const maxOverlaysOnShot = 8;
export const maxOverlayAlertMs = 4000;

export const MEDIA_UPLOAD_ERROR_TYPES = {
	CREATE_OVERLAY: 'create-overlay',
	FILE_NAME: 'file-name',
	FILE_NAME_LENGTH: 'file-name-size',
	FILE_READ: 'file-read',
	FILE_SIZE: 'file-size',
	FILE_TYPE: 'file-type',
	FILE_UPLOAD: 'file-upload',
};

export const MEDIA_UPLOAD_ERROR_MESSAGES = {
	[MEDIA_UPLOAD_ERROR_TYPES.CREATE_OVERLAY]: 'Cannot Create Overlay',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_NAME]: 'Please remove characters',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_NAME_LENGTH]: 'Invalid File Name Length',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_READ]: 'Error Loading Media',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_SIZE]: 'File Too Large',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_TYPE]: 'Unsupported File Type',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_UPLOAD]: 'File Upload Error',
};

export const MEDIA_UPLOAD_ERROR_DESCRIPTIONS = {
	[MEDIA_UPLOAD_ERROR_TYPES.CREATE_OVERLAY]: 'Accepted Overlay file types include: .jpg, .jpeg, .png, .mp4, .mov, .webm, .gif',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_NAME]: 'You cannot use special characters in your title.',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_NAME_LENGTH]: 'File name (including extension) must be between 1 and 200 characters.',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_READ]: 'An error occurred while trying to upload your media file. Try loading the file again.',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_SIZE]: 'The maximum file size for uploads is 5GB.',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_TYPE]: 'Please upload an image, .pptx, .pdf, .mp4, .mov or .webm file.',
	[MEDIA_UPLOAD_ERROR_TYPES.FILE_UPLOAD]: 'The file selected could not be uploaded.',
};

export const MAX_FILE_NAME_LENGTH = 200;

export const MEDIA_UPDATED_EVENTS = {
	DOWNLOAD_READY: 'download-ready',
};

export const ALERT_EVENTS = {
	MEDIA_UPDATED: 'media-updated',
};

export const BROWSER_TYPES = {
	UNKNOWN: 'unknown',
	CHROME: 'chrome',
	FIREFOX: 'firefox',
	INTERNET_EXPLORER: 'internet-explorer',
	SAFARI: 'safari',
	MICROSOFT_EDGE: 'microsoft-edge',
};

export const MAX_AUDIO_ONLY_FEEDS = 8;

export const ACTIVITY_TYPES = {
	LOGIN: 'LOGIN',
	DAILY_LOGIN: 'DAILY_LOGIN',
};
export const SUPPORTED_CHAT_FILE_FORMATS = {
	FILE_TYPES: [
		'pdf',
		'pptx',
		'ppt',
		'docx',
		'doc',
		'xls',
		'xlsx',
		'txt',
		'csv',
		'mp4',
		'mp3',
		'wav',
		'weba',
		'mov',
		'mpeg',
		'webm',
		'm3u8',
		'jpg',
		'jpeg',
		'png',
		'gif',
		'svg',
	],
	MIME_TYPES: [
		'application/pdf',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'application/vnd.ms-powerpoint',
		'application/msword',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/vnd.ms-excel',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'text/plain',
		'text/csv',
		'video/mp4',
		'audio/mp3',
		'audio/wav',
		'audio/webm',
		'video/quicktime',
		'video/mpeg',
		'video/webm',
		'application/x-mpegURL',
		'vnd.apple.mpegURL',
		'image/jpeg',
		'image/png',
		'image/gif',
		'image/svg+xml',
	],
	PICTURE_MIME_TYPES: [
		'image/jpeg',
		'image/png',
	],
};

// width of chars relative to capital W
export const CHARACTER_WIDTHS = {
	a: 60,
	b: 60,
	c: 52,
	d: 60,
	e: 60,
	f: 35,
	g: 60,
	h: 60,
	i: 25,
	j: 25,
	k: 52,
	l: 25,
	m: 87,
	n: 60,
	o: 60,
	p: 60,
	q: 60,
	r: 35,
	s: 52,
	t: 30,
	u: 60,
	v: 52,
	w: 77,
	x: 52,
	y: 52,
	z: 52,
	A: 70,
	B: 70,
	C: 77,
	D: 77,
	E: 70,
	F: 65,
	G: 82,
	H: 77,
	I: 30,
	J: 55,
	K: 70,
	L: 60,
	M: 87,
	N: 77,
	O: 82,
	P: 70,
	Q: 82,
	R: 77,
	S: 70,
	T: 65,
	U: 77,
	V: 70,
	W: 100,
	X: 70,
	Y: 70,
	Z: 65,
	',': 30,
	'.': 30,
	' ': 30,
	'/': 30,
	'-': 30,
};

export const OPENTOK_CONSTANTS = {
	SIGNALS: {
		FORCE_SET_AUDIO: 'forceSetAudio',
		FORCE_SET_VIDEO: 'forceSetVideo',
	},
};

export const LANDING_PAGE_TYPES = {
	ACCOUNT_DELETED: 'accountDeleted',
	UNHANDLED_THROWN_ERROR: 'unhandledThrownError',
};

export const SOCKET_MESSAGE_TYPES = {
	GREENROOM_ALERT: 'greenroom-alert',
};

export const DOWNLOAD_TYPES = {
	RECORDING: 'recording',
	FILE: 'file',
	SINGLE_ISO: 'iso',
};

export const CONNECTED_PRESENTER_VIDEO_TYPES = {
	CAMERA: 'camera',
	SCREENSHARE: 'screen',
};

export const UPLOAD_TYPES = {
	MEDIA: 'media',
	PAGE: 'page',
	OVERLAY: 'overlay',
};

export const UPLOAD_STATUS = {
	LOAD: 'load',
	ABORT: 'abort',
	ERROR: 'error',
};

export const CLOUD_CONVERT_STATUS = {
	FAILED: 'failed',
	IN_PROGRESS: 'in_progress',
	COMPLETE: 'complete',
};
